import type { EntryStrategyReview } from '@shared/domain/review';
import React from 'react';
import { ReviewStep } from '@shared/domain/review';
import { ENTRY_STRATEGY_FORM_FIELDS } from '../../data';
import { BaseReviewForm } from '../BaseReviewForm';

export interface EntryStrategyReviewProps {
  submitReviewForm?: (
    formFields: EntryStrategyReview,
    reviewStep: ReviewStep,
    isDraft?: boolean,
  ) => void;
  editMode?: boolean;
  defaultValues?: Partial<EntryStrategyReview> & { id?: number };
  handleEditSuccess?: () => void;
}

function EntryStrategyReviewForm(props: EntryStrategyReviewProps) {
  return (
    <BaseReviewForm<EntryStrategyReview>
      reviewStep={ReviewStep.ENTRY_STRATEGY}
      formFields={ENTRY_STRATEGY_FORM_FIELDS}
      containerTestId="entry-strategy-review-step-content-anchor"
      submitButtonText="Continue to Purchase Details"
      editMode={props.editMode}
      defaultValues={props.defaultValues}
      onSubmit={props.submitReviewForm}
      onEditSuccess={props.handleEditSuccess}
    />
  );
}

export default EntryStrategyReviewForm;
